import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import constants from '../../../_consts';

Vue.use(VueAxios, axios);

const getters = {
  GETTERS_SHOW_RELATED_EVENT: (state) => {
    return state.showRelatedEvents;
  },
  GETTERS_LIST_EVENT_RELATED: (state) => {
    return state.listEventRelated;
  },
  GETTERS_LIST_EVENT_STATUS: (state) => {
    return state.listEventStatus;
  },
  GETTERS_LIST_EVENT: (state) => {
    return state.listEvent;
  },
  GETTERS_COUNT_EVENT_BY_STATUS: (state) => status => {
    let statusArr = [status];
    if (status === '') {
      statusArr = state.listEventStatus;
    }
    let count = 0;
    for (let countObj of state.countTotalEvent) {
      for (let statusItem of statusArr) {
        if (countObj.status.toLowerCase() === statusItem.toLowerCase()) {
          count += countObj.count;
        }
      }
    }
    return count;
  },
  GETTERS_COUNT_UNREAD_EVENT_BY_STATUS: (state) => status => {
    let statusArr = [status];
    if (status === '') {
      statusArr = state.listEventStatus;
    }
    let count = 0;
    for (let countObj of state.countTotalEvent) {
      for (let statusItem of statusArr) {
        if (countObj.status.toLowerCase() === statusItem.toLowerCase()) {
          count += countObj.unread;
        }
      }
    }
    return count;
  },
  GETTERS_GET_EXPAND_ID: (state) => {
    return state.expandId;
  },
  GETTERS_GET_ITEM_RELATED_INFO: (state) => {
    return state.relatedItemInfo;
  },
  GETTERS_GET_COLUMN_WIDTH: (state) => {
    return state.columnWidth;
  },
  GETTERS_LIST_ON_SITE_CONTACT: (state) => {
    return state.listOnSiteContact;
  },
  GETTERS_CREATE_EVENT_FLAG: (state) => {
    return state.flagCreateEvent;
  },
  GETTERS_SUBMIT_ALL_EVENT_SUCCESS: (state) => {
    return state.submitAllEventSuccess;
  },
  GETTERS_MESSAGE_ERROR: (state) => {
    return state.messageError;
  },
  GETTERS_GET_LOCK_IDS: (state) => {
    return state.lockIds;
  },
  GETTERS_ERROR_CODES: (state) => {
    return state.errorCodes;
  },
  GETTERS_IS_LOADING: (state) => {
    return state.isLoading;
  },
  GETTERS_IS_UPDATING: (state) => {
    return state.isUpdating;
  },
  GETTERS_GET_EVENT_HISTORY: (state) => {
    let histories = state.histories;

    if (histories.length === 0) {
      return [];
    }

    let result = [];
    histories.forEach((history, index) => {
      let fields = history.fieldsChange;
      let items = [];
      fields.forEach((field, index) => {
        let newCustom = '';
        let previousCustom = '';
        if (field.fieldName === 'ADDITIONAL SERVICES') {
          let newValue = constants.cleanArray(field.newValue.split(',')).join();
          let previousValue = constants.cleanArray(field.previousValue.split(',')).join();
          let listAdditionalServicesKey = constants.listAdditionalServicesKey;
          for (const key in listAdditionalServicesKey) {
            if (listAdditionalServicesKey.hasOwnProperty(key)) {
              const element = listAdditionalServicesKey[key];
              let text = constants.mappingKeyToTextAdditionalServices(element);
              newCustom = newCustom === '' ? newValue.replace(key, ' ' + text) : newCustom.replace(key, ' ' + text);
              previousCustom = previousCustom === '' ? previousValue.replace(key, ' ' + text) : previousCustom.replace(key, ' ' + text);
            }
          }
        }
        items.push({
          fields: field.fieldName,
          new_value: newCustom === '' ? field.newValue : newCustom,
          previous_value: previousCustom === '' ? field.previousValue : previousCustom
        });
      });
      result.push({
        userName: history.userName,
        timeModified: history.timeModified,
        fieldsChangeCount: history.fieldsChangeCount,
        items: items,
        additionalComment: history.additionalComment
      });
    });
    return result;
  },
  GETTERS_GET_EVENT_DETAIL_HISTORY: state => state.eventDetailHistory,
  GETTERS_GET_IS_LOADING_EVENT_DETAIL_HISTORY: state => state.isLoadingEventDetailHistory,
  GETTER_GET_COLUMN_TABLE_USER: state => state.columnTableUserWidth,
  GETTER_GET_COLUMN_TABLE_STAFFING: state => state.columnTableStaffingWidth,
  GETTERS_EVENTS_BY_DATES: (state) => {
    return state.listApprovedEvent
  },
  GETTERS_TOTAL_EVENTS: (state) => {
    return state.totalApprovedEvents
  },
  GETTERS_DATES_HAS_DATA: (state) => {
    return state.datesHasData;
  },
  GETTERS_LOCKED_DATES: (state) => {
    return state.lockedDates;
  },
  GETTERS_DATE_RANGE_HAS_DATA: (state) => {
    return state.dateRangeHasData;
  },
  GETTER_IS_LOADING_MODAL: (state) => {
    return state.isLoadingModal;
  },
  GETTER_IS_LOADING_PARTICIPANT: (state) => {
    return state.isLoadingParticipant;
  },
  GETTER_GET_EVENT_FOR_CHANGE_ORDER: (state) => {
    return state.eventDetailChangeOrder;
  },
  GETTER_GET_STAFF_LIST: (state) => {
    return state.staffList;
  },
  GETTER_GET_OPEN_ASSIGN_STAFF_MODAL: (state) => {
    return state.openEventStaffModal;
  },
  GETTER_GET_STAFF_ASSIGN_LIST: (state) => (type) => {
    switch (type) {
      case 'lead':
        return state.staffLead;
      case 'screener':
        return state.staffScreener;
      case 'phlebotomist':
        return state.staffConcierge;
      default:
        return [];
    }
  },
  GETTER_GET_EVENT_LIST_REPORTS: (state) => {
    return state.manageEventReports;
  },
  GETTER_GET_SLIDER_VALUE_REPORTS: (state) => {
    return state.sliderValue;
  },
  GETTER_GET_STAFF_DETAIL: (state) => {
    return state.staffDetail;
  },
  GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES: state => state.colTableEmailHistories,
  GETTER_LIST_EVENT_GROUP: state => state.listEventGroup,
  GETTER_LIST_SINGLE_EVENT: state => state.listSingleEvent,
  GETTER_CURRENT_EVENT: state => state.currentEvent,
  GETTER_IS_DOWNLOADING: state => state.isDownloading
};

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/events/getters.js